import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useCourtFiles } from '../court-files';
import { useColumns } from '../register-new/court-file-register-new-columns';

export const COURT_FILES_INDEX_IDENTIFIER = 'COURT_FILES_INDEX';
export const COURT_FILES_INDEX_VERSION = 4;

export function CourtFilesIndex() {
  const intl = useIntl();

  const columns = useColumns();

  const { evidenceBag } = useCourtFiles({
    evidenceProps: {
      identifier: COURT_FILES_INDEX_IDENTIFIER,
      version: COURT_FILES_INDEX_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.INDEX,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__COURT_FILES_INDEX__TABLE__TITLE',
          defaultMessage: 'Soudní spisy - Indexace',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (button) => {
            if (button === 'NEW') {
              return false;
            }
            return true;
          },
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
